module.exports = __webpack_public_path__ + "static/media/search.200b5b68.svg";